export enum ShopsMapPointType {
	Services = 'services',
	Shops = 'shops'
}
